import styled from "styled-components"

const StyledExperienceContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: auto;
  grid-gap: 2rem;
  margin-top: 0.25rem;
  
  {/* Medium devices (landscape tablets, 768px and up)*/}
  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
`

export default StyledExperienceContentGrid